import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Banner extends Component {

    static defaultProps = {
        image: null,
        height: 400,
        imagePositionX: 'center',
        imagePositionY: 'center',
        imageHeight: 'auto',
        imageWidth: '100%',
        title: null,
        content: null,
        containerImage: false,
        blur: false,
        backgroundColor: null
    }

    static propTypes = {
        image: PropTypes.string,
        title: PropTypes.string,
        content: PropTypes.string
    }

    render() {
        return (
            <div>
                {this.props.image ? <div className="g-bg-cover g-bg-black-opacity-0_1--after"><div
                    style={{ 
                        "backgroundImage" : `url(${this.props.image})`,
                        "backgroundSize" : `${this.props.imageWidth} ${this.props.imageHeight}`,
                        "backgroundRepeat": `no-repeat`,
                        "backgroundPositionX": this.props.imagePositionX,
                        "backgroundPositionY": this.props.imagePositionY,
                        "height" : this.props.height,
                        "filter" : this.props.blur ? `blur(3px)` : `blur(0px)`,
                        "backgroundColor" : this.props.backgroundColor,
                    }}
                    className={ this.props.containerImage ? `container ` : `` }>
                </div>
                    {this.props.title || this.props.content ?
                    <div className="g-mt-30 g-absolute-centered g-py-20 g-bg-black-opacity-0_4">
                        <div className="row align-items-stretch">
                            <div className="text-center g-flex-middle g-bg-cover g-bg-size-cover text-uppercase g-px-30">
                            { this.props.title ? <h2 className="g-font-weight-700 text-uppercase g-color-white">{this.props.title}</h2> : null}
                            { this.props.content ? 
                                <p className="g-color-white mb-2">{this.props.content}</p>
                            : null }
                            </div>
                        </div>
                    </div> : null}
                </div> : null}
            </div>
        );
    }
}

export default Banner;


// WEBPACK FOOTER //
// ./src/layout/Banner.js